import { useEffect } from 'react';
import { useBrandData } from '../context/PortalDataContext';
import { redirectToIdleLogout } from '../utils/loginRedirect';
import { getPortalSessionMode } from '../utils/portalSessionMode';

const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'touchstart',
  'click',
  'keydown',
] as const;

const IDLE_CHECK_INTERVAL_MS = 1000;

export type UseIdleSessionTimeoutOptions = {
  enabled: boolean;
};

export function useIdleSessionTimeout({
  enabled,
}: UseIdleSessionTimeoutOptions): void {
  const timeoutSeconds =
    useBrandData()?.context?.membershipSessionTimeoutDurationSeconds;
  const timeoutMs =
    enabled &&
    typeof timeoutSeconds === 'number' &&
    timeoutSeconds > 0 &&
    getPortalSessionMode() === 'live'
      ? timeoutSeconds * 1000
      : undefined;

  useEffect(() => {
    if (timeoutMs === undefined) {
      return undefined;
    }
    let lastActivityMs = Date.now();
    let hasRedirected = false;

    const recordActivity = () => {
      lastActivityMs = Date.now();
    };

    ACTIVITY_EVENTS.forEach((eventName) =>
      window.addEventListener(eventName, recordActivity, {
        passive: true,
        capture: true,
      })
    );

    const intervalId = window.setInterval(() => {
      if (!hasRedirected && Date.now() > lastActivityMs + timeoutMs) {
        hasRedirected = true;
        redirectToIdleLogout();
      }
    }, IDLE_CHECK_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
      ACTIVITY_EVENTS.forEach((eventName) =>
        window.removeEventListener(eventName, recordActivity, {
          capture: true,
        })
      );
    };
  }, [timeoutMs]);
}
